require('./contractLoanSliders.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const OKSliderInput = require('commonsComponents/OKSliderInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
//@core
const { FormattedText, formatText, hasTranslation, getLanguage } = require('core/i18n').i18n;
//@utilities
const { decimalsLength, getFormattedString, formatAmount } = require('utilities/currencyHelper');
const { recordEasyLoanCAmountValue, recordEasyLoanCTermValue } = require('../contractEasyLoanTypeC/analytics/contractEasyLoanTypeC.tracking');

// @constants
const { EURO_SYMBOL } = require('constants/index');
const { payrollLoanCommon, payrollLoanLayoutKOxDTI, LOANS_MORTGAGES_EASY_LOAN_TYPE_C } = require('../../../loansConstants/index');

class ContractLoanSliders extends React.Component {
    constructor(props) {
        super(props);

        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleTermChange = this.handleTermChange.bind(this);
        this.handleAmountInputChange = this.handleAmountInputChange.bind(this);
    }
    
    componentDidMount() {
        const selectedAmount = this.props.immContractLoan.get('selectedAmount');
        this.props.setLoanAmount({ amount: selectedAmount });
        this.handleAmountChange(selectedAmount);
    }

    handleAmountInputChange(selectedAmount) {
        const { productType } = this.props;
        if(productType === LOANS_MORTGAGES_EASY_LOAN_TYPE_C) {
            recordEasyLoanCAmountValue();
        }
        this.handleAmountChange(selectedAmount);
    }
    
    //  *** Handlers ***
    handleAmountChange(selectedAmount) {
        const {
            amountMaxInstallment,
            getInstallment,
            setLoanAmount,
            getMinInstallment,
            getMinTerm,
            immContractLoan,
        } = this.props;

        // validate if the value is not undefined to avoid redirection to error page
        if (selectedAmount) {
            const max = immContractLoan.get('maxAmount');
            const min = immContractLoan.get('minAmount')
            if (max <= min) {
                setLoanAmount({ selectedAmount: 0 });
            } else {
                setLoanAmount({ selectedAmount });
                getInstallment(amountMaxInstallment);

                if (getMinTerm) {
                    getMinTerm();
                }
                if (getMinInstallment) {
                    getMinInstallment();
                }
            }
        }
    }

    handleTermChange(term) {
        //validate if the value is not undefined to avoid redirection to error page
        if (term) {
            const { setLoanTerm, getInstallment } = this.props;
            recordEasyLoanCTermValue();
            setLoanTerm({ term });
            getInstallment(); // this argument calls the service using the current selected term.
        }
    }

    buildTooltip() {
        return (
            <OKTooltip
                content={formatText('contractEasyLoanStepOne-minimunTermTooltip')}
                offset={[0, -15]}
            />
        );
    }

    buildAmountSlider() {
        const {
            amountTitle,
            callFromKOxDTI,
            customValues,
            immContractLoan,
            isCollective,
            isDragoFeature,
            isMaxAmountError
        } = this.props;

        const formatCurrency = (amount) => getFormattedString({
            amount,
            currency: immContractLoan.get('currency'),
            decimalsLength: decimalsLength(amount)
        });

        const disabled = !!immContractLoan.get('isFetchingInstallment') || !!isMaxAmountError;
        const step = payrollLoanCommon.AMOUNT_STEP_VALUE;
        const inputMark = EURO_SYMBOL;

        const min = immContractLoan.get('minAmount');
        const amountMin = formatCurrency(min);

        const maxCollective = isCollective ? immContractLoan.getIn(['collectiveInformation', '0', 'maxAmount'], payrollLoanLayoutKOxDTI.MAX_AMOUNT_COLLECTIVE) : 0;
        const maxAmount = immContractLoan.get('maxAmount');
        const max = isCollective && !callFromKOxDTI ? maxCollective : maxAmount;
        const amountMax = formatCurrency(max);
        const amountMaxSlashed = isCollective ? formatCurrency(maxAmount) : null;
        const amountMaxNoSymbol = formatAmount(max, getLanguage(), 0);

        const minLabel = `${formatText('contractLoanSliders-contractLoanSliders_amountMin')} ${min}`;

        const selectedAmountRaw = customValues ? customValues.get('selectedAmount') :
            immContractLoan.get('selectedAmount');
        const defaultValue = selectedAmountRaw || 0;
        const errorMessage = formatText('contractLoanSliders-amountError', [amountMin, amountMax]);
        const errorState = defaultValue > max || defaultValue < min;

        let firstTitle;
        let strikedText;

        if (isCollective) {
            strikedText = (
                <s className="contract-loan-sliders__max-label-slashed-s">
                    <span>
                        {amountMaxSlashed}
                    </span>
                </s>
            );
        }
        const maxLabel = (
            <React.Fragment>
                <FormattedText value="contractLoanSliders-contractLoanSliders_amountMax" /> {strikedText} {amountMaxNoSymbol}
            </React.Fragment>
        );

        if (!!amountTitle) {
            firstTitle = hasTranslation(amountTitle) ? formatText(amountTitle) : amountTitle;
        } else {
            firstTitle = formatText('contractLoanSliders-firstSliderTitle');
        }
        const valueLabelType = isDragoFeature ? 'label' : 'default';
        const classNameSlider = isDragoFeature ? 'contract-loan-sliders__slider-with-drago' :
            'contract-loan-sliders__slider';

        return (
            <div className={classNameSlider}>
                <OKSliderInput
                    defaultValue={defaultValue}
                    disabled={disabled}
                    errorMessage={errorMessage}
                    errorState={errorState}
                    inputType="format"
                    max={max}
                    maxLabel={maxLabel}
                    min={min}
                    minLabel={minLabel}
                    onChange={this.handleAmountInputChange}
                    step={step}
                    title={firstTitle}
                    unit={inputMark}
                    valueLabelType={valueLabelType}
                />
            </div>
        );
    }

    buildTermSlider() {
        const {
            customValues,
            immContractLoan,
            isDragoFeature,
            showTooltip,
            termTitle,
        } = this.props;

        const disabled = !!immContractLoan.get('isFetchingInstallment');
        const inputMark = formatText('contractLoanSliders-contractLoanSliders_months');
        const step = payrollLoanCommon.TERM_STEP_VALUE;

        const max = immContractLoan.get('maxTerm');
        const min = immContractLoan.get('minTerm') > max ? max : immContractLoan.get('minTerm');

        const minLabel = `${formatText('contractLoanSliders-contractLoanSliders_termMin')} ${min}`;
        const maxLabel = `${formatText('contractLoanSliders-contractLoanSliders_termMax')} ${max}`;
        const selectedTermRaw = customValues ? customValues.get('selectedTerm') : immContractLoan.get('selectedTerm');
        const defaultValue = selectedTermRaw || 0;
        const errorMessage = formatText('contractLoanSliders-termError', [min, max]);
        const errorState = defaultValue > max || defaultValue < min;

        let tooltip;
        let secondTitle;

        if (showTooltip) {
            tooltip = this.buildTooltip();
        }

        if (termTitle) {
            secondTitle = hasTranslation(termTitle) ? formatText(termTitle) : termTitle;
        } else {
            secondTitle = formatText('contractLoanSliders-secondSliderTitle');
        }
        const valueLabelType = isDragoFeature ? 'label' : 'default';
        const classNameSlider = isDragoFeature ? 'contract-loan-sliders__slider-with-drago' :
            'contract-loan-sliders__slider';

        return (
            <div className={classNameSlider}>
                <OKSliderInput
                    defaultValue={defaultValue}
                    disabled={disabled}
                    extraInfo={tooltip}
                    errorMessage={errorMessage}
                    errorState={errorState}
                    max={max}
                    maxLabel={maxLabel}
                    min={min}
                    minLabel={minLabel}
                    onChange={this.handleTermChange}
                    step={step}
                    title={secondTitle}
                    unit={inputMark}
                    valueLabelType={valueLabelType}
                />
            </div>
        );
    }

    render() {
        const { showSectionTitle } = this.props;

        const sectionTitle = showSectionTitle ? <FormattedText value="contractLoanSliders-sliderSectionTitle" /> : null;
        const termSlider = this.buildTermSlider();
        const amountSlider = this.buildAmountSlider();

        return (
            <div className="contract-loan-sliders__slider-section">
                <div className="contract-loan-sliders__slider-section-title">
                    {sectionTitle}
                </div>
                {amountSlider}
                {termSlider}
            </div>
        );
    }
}

ContractLoanSliders.propTypes = {
    amountMaxInstallment: PropTypes.bool,
    amountTitle: PropTypes.string,
    customValues: PropTypes.object,
    getInstallment: PropTypes.func.isRequired,
    getMinInstallment: PropTypes.func,
    immContractLoan: PropTypes.object.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    showSectionTitle: PropTypes.bool,
    termTitle: PropTypes.string,
    showTooltip: PropTypes.bool,
    getMinTerm: PropTypes.func,
    callFromKOxDTI: PropTypes.bool,
    isCollective: PropTypes.bool,
    isDragoFeature: PropTypes.bool,
    isMaxAmountError: PropTypes.bool,
    productType: PropTypes.string,
};

ContractLoanSliders.defaultProps = {
    callFromKOxDTI: false,
    isCollective: false,
    productType: '',
};

module.exports = ContractLoanSliders;
